<template>
  <button @click="$emit('click')" type="button" :class="'btn btn-'+buttonClass+''">
    <i :class="iconClass"></i>
    <span>{{providerLabel}}</span>
  </button>
</template>

<script>
export default {
  props: {
    iconClass: {
      type: String,
      required: true
    },
    buttonClass: {
      type: String,
      required: true
    },
    providerLabel: {
      type: String,
      required: true
    }
  }
};
</script>


<style lang="scss" scoped>
i {
  margin-right: 0.5rem;
  font-size: 22px;
}
</style>

